var _defs, _circle, _circle2, _path, _path2, _circle3, _path3, _path4, _polygon, _path5, _polygon2, _path6, _line, _circle4, _circle5, _path7, _path8, _path9, _path10, _path11, _path12, _polygon3, _polygon4, _path13, _circle6, _circle7, _path14, _path15, _path16, _circle8, _path17, _circle9, _path18, _polygon5, _polygon6, _path19, _path20, _line2, _line3, _line4, _line5, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f85565;}.cls-2,.cls-4,.cls-6{fill:#ffffff;}.cls-2{opacity:0.2;}.cls-3{fill:#f2bc0f;}.cls-4,.cls-8{opacity:0.5;}.cls-5{fill:#fba875;}.cls-14,.cls-7{fill:#356cb6;}.cls-15,.cls-8{fill:#393c54;}.cls-11,.cls-12,.cls-17,.cls-18,.cls-9{fill:none;stroke-linecap:round;}.cls-9{stroke:#fba875;stroke-miterlimit:10;stroke-width:20px;}.cls-10{fill:#ffbb94;}.cls-11,.cls-12{stroke:#515570;}.cls-11,.cls-12,.cls-17,.cls-18{stroke-linejoin:round;}.cls-11,.cls-12,.cls-18{stroke-width:2px;}.cls-11{opacity:0.4;}.cls-12,.cls-14{opacity:0.1;}.cls-13{fill:#ff8475;}.cls-16{fill:#f8dc25;}.cls-17{stroke:#f2bc0f;stroke-width:3px;}.cls-18{stroke:#ff8475;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34,77.5V50.86c0-16.38,12.84-30.25,29.21-30.67A30.07,30.07,0,0,1,94,50.34V77.5A5.5,5.5,0,0,1,88.5,83h-49A5.5,5.5,0,0,1,34,77.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34,50.46V58H94V49.88h0A8.89,8.89,0,0,0,85.11,41H43a9,9,0,0,0-9,8.77C34,50,34,50.23,34,50.46Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 88.5,
    cy: 63.5,
    r: 7.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64,124.1a59.78,59.78,0,0,0,40-15.28l-2.39-5.68c-1.71-4-6.22-6.64-11.29-6.64H37.69c-5.07,0-9.58,2.66-11.29,6.64L24,108.82A59.78,59.78,0,0,0,64,124.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47,96.5H37.69c-5.07,0-9.58,2.66-11.29,6.64L24,108.82a59.84,59.84,0,0,0,33.07,14.87Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "46.98 96.5 56.68 123.17 40.88 108 46.27 105.32 37.69 96.5 46.98 96.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.11,96.5H90.4c5.06,0,9.58,2.66,11.29,6.64l2.39,5.68A59.84,59.84,0,0,1,71,123.69Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "81.11 96.5 71.41 123.17 87.2 108 81.82 105.32 90.4 96.5 81.11 96.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.72,98.25a3.06,3.06,0,0,0-3.08-2.88H49.36a3.07,3.07,0,0,0-3.08,2.93c0,.11,0,.21,0,.32l10.52,16.64L64,108.05l7.17,7.17S81.73,98.49,81.73,99C81.73,99.26,81.73,98.49,81.72,98.25Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 64,
    x2: 64,
    y1: 86,
    y2: 98
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 63.5,
    cy: 86.5,
    r: 9.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 38.5,
    cy: 63.5,
    r: 7.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M38,73.68V51.61c0-13.22,9.7-24.7,22.82-26.25A26,26,0,0,1,90,51.12V73.68A18.32,18.32,0,0,1,71.68,92H56.32A18.32,18.32,0,0,1,38,73.68Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M60.19,84.14a6.43,6.43,0,0,1,7.33,0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,71h0a3,3,0,0,1-3-3V50h6V68A3,3,0,0,1,64,71Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M70.65,86.31a6.87,6.87,0,0,1-13.74,0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.16,123.86c1.27.08,2.55.14,3.84.14s2.57-.06,3.84-.14L67,115H61Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M64.58,117.22H63.26a4.58,4.58,0,0,1-4.58-4.58V108H69.17v4.64A4.58,4.58,0,0,1,64.58,117.22Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "64 108 74.17 95.38 78.64 95.38 71.17 115.22 64 108"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "64 108 53.83 95.38 49.36 95.38 56.83 115.22 64 108"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M81.72,98.25a3.06,3.06,0,0,0-3.08-2.88H74.17L64,108,53.83,95.37H49.36a3.06,3.06,0,0,0-3.08,2.92c0,.11,0,.21,0,.32l10.52,16.64L64,108.05l7.17,7.17L81.73,99C81.73,98.74,81.73,98.49,81.72,98.25Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 50.5,
    cy: 58.5,
    r: 5.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 51,
    cy: 59,
    r: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M30,25H70.9A16.86,16.86,0,0,1,87.77,41.86h0A8.14,8.14,0,0,1,79.63,50H53.78A23.78,23.78,0,0,1,30,26.22Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M80.5,44.5h-26a18.42,18.42,0,0,1-5.23-.75A18.2,18.2,0,0,1,36.5,26.18V23.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M76.5,38.5H54.26a12.92,12.92,0,0,1-8.56-3.21"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 77.5,
    cy: 58.5,
    r: 5.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M56,58.5a5.5,5.5,0,0,1-11,0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 77,
    cy: 59,
    r: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83,58.5a5.5,5.5,0,0,1-11,0"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "85.8 52 71.63 52 70.63 56 83.8 56 85.8 52"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "42.23 52 56.4 52 57.4 56 44.23 56 42.23 52"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M57.23,66.73l-1,2.71a3.54,3.54,0,0,1-3.32,2.33h0a3.52,3.52,0,0,0-3.38,2.5l-1.07,3.52"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M70.47,66.73l1,2.71a3.52,3.52,0,0,0,3.31,2.33h0a3.52,3.52,0,0,1,3.38,2.5l1.07,3.52"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 85,
    x2: 87,
    y1: 59,
    y2: 59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 85.17,
    x2: 87.37,
    y1: 61.75,
    y2: 62.66
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 42,
    x2: 40,
    y1: 59,
    y2: 59
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 42.47,
    x2: 40.27,
    y1: 61.75,
    y2: 62.66
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "72 80.68 70 78 58 78 56 80.68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar4);
export default __webpack_public_path__ + "static/media/avatar4.a8d395cf6ac04d3c6f9f4f2e04c07678.svg";
export { ForwardRef as ReactComponent };